import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function getBudget({ budgetId }){

    const response = await axiosInstance.get(
        `${API_URL}/budgets/getBudget/${budgetId}`
    );
    return response;
}